import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { getMascotImageSrc } from '@gem/utils';

import styles from './EmptyComponent.styles.m.css';

interface IEmptyComponent {
  isSearchMode: boolean;
}

export const EmptyComponent: FC<IEmptyComponent> = ({ isSearchMode }) => {
  const { t } = useTranslation();

  if (isSearchMode) {
    return <div className={styles.noContent}>{t('search_no_results')}</div>;
  }

  const image = getMascotImageSrc(PROJECT_CONFIG.imageAssets.contacts);

  return (
    <div className={styles.noContent}>
      {image && (
        <img
          src={image}
          width={192}
          height={176}
          alt={''}
          className={styles.img}
        />
      )}
      {t('no_contacts_in_gem4me')}
    </div>
  );
};
